
























/** @format */

import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

@Component
export default class ParkingLotTreeLeft extends Vue {
  private treeSearchValue: string = '';
  private expandedKeys: string[] = [];
  private autoExpandParent: boolean = false;
  private dataList: any[] = [];
  // 替换参数字段
  private replaceFields: any = {
    children: 'children',
    title: 'title',
    key: 'id'
  };

  @Prop({
    type: Boolean,
    default() {
      return false;
    }
  })
  defaultExpandAll!: boolean;
  // 左侧车场树列表
  @Prop({
    type: Array,
    default() {
      return [];
    }
  })
  parkingLotTreeData!: any;

  @Prop({
    type: Array,
    default() {
      return [];
    }
  })
  defaultSelectedKeys!: any;

  @Watch('defaultSelectedKeys', {
    deep: true
  })
  onChangeDefaultSelectedKeys(newVal: any, oldVal: any) {
    if (newVal.length > 0) {
      this.expandedKeys = newVal;
      this.autoExpandParent = true;
    } else {
      // 默认展开一级
      this.expandedKeys = this.parkingLotTreeData.length > 0 ? [this.parkingLotTreeData[0].id] : [];
      this.autoExpandParent = true;
    }
    console.log('this.expandedKeys', this.expandedKeys);
  }

  // 监听左侧车场树数据变化
  @Watch('parkingLotTreeData', {
    deep: true,
    immediate: true
  })
  onChangeParkingLotTreeData(newVal: any, oldVal: any) {
    if (this.defaultSelectedKeys.length > 0) {
      this.expandedKeys = this.defaultSelectedKeys;
      this.autoExpandParent = true;
    } else {
      // 默认展开一级
      this.expandedKeys = newVal.length > 0 ? [newVal[0].id] : [];
      this.autoExpandParent = true;
    }

    this.generateDataList(newVal);
  }

  // 构建查询列表数据
  private generateDataList(data: any) {
    let { replaceFields } = this;
    for (let i = 0; i < data.length; i++) {
      let node = data[i];
      this.dataList.push({ [replaceFields.key]: node[replaceFields.key], title: node[replaceFields.title] });
      if (node[replaceFields.children]) {
        this.generateDataList(node[replaceFields.children]);
      }
    }
  }

  // 获取父级KEY
  private getParentKey(key: any, tree: any): any {
    let { replaceFields } = this;
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
      let node = tree[i];
      if (node[replaceFields.children]) {
        if (node[replaceFields.children].some((item: any) => item[replaceFields.key] === key)) {
          parentKey = node[replaceFields.key];
        } else if (this.getParentKey(key, node[replaceFields.children])) {
          parentKey = this.getParentKey(key, node[replaceFields.children]);
        }
      }
    }
    return parentKey;
  }

  handleExpand(expandedKeys: string[]) {
    this.expandedKeys = expandedKeys;
    this.autoExpandParent = false;
  }

  // 筛选节点
  handleFilterNode(event: any) {
    let { replaceFields } = this;
    let value = (event.target as HTMLInputElement).value;
    let expandedKeys = this.dataList
      .map((item: any) => {
        if (item[replaceFields.title].indexOf(value) > -1) {
          return this.getParentKey(item[replaceFields.key], this.parkingLotTreeData);
        }
        return null;
      })
      .filter((item: any, i: any, self: any) => item && self.indexOf(item) === i);
    // console.log(expandedKeys)
    Object.assign(this, {
      expandedKeys,
      treeSearchValue: value,
      autoExpandParent: true
    });
  }

  // 选择节点
  @Emit('on-select')
  handleNodeClick(selectedKeys: any, event: any) {
    return {
      selectedKeys,
      event: event
    };
  }
  //清空搜索条件
  clearSearch() {
    this.treeSearchValue = '';
  }
  created() {
    if (this.defaultExpandAll) {
      this.expandedKeys = [];
      for (var i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].id) {
          this.expandedKeys.push(this.dataList[i].id);
        }
      }
    }
  }
}
